import { render, staticRenderFns } from "./logisticsProcess.vue?vue&type=template&id=7b5d1f31&scoped=true"
import script from "./logisticsProcess.vue?vue&type=script&lang=js"
export * from "./logisticsProcess.vue?vue&type=script&lang=js"
import style0 from "./logisticsProcess.vue?vue&type=style&index=0&id=7b5d1f31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5d1f31",
  null
  
)

export default component.exports